// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventSummaryModal-module_root___gILFl {
  padding: 20px 15px 20px 15px;
  min-height: 260px;
  display: flex;
  flex-direction: column;
}
.EventSummaryModal-module_root___gILFl .EventSummaryModal-module_headliner___ZsqPi {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 1.8rem;
}
.EventSummaryModal-module_root___gILFl .EventSummaryModal-module_bottomInfo___oV5Eb {
  align-items: center;
  display: flex;
  gap: 2rem;
  font-size: 1.4rem;
  padding: 10px 0 0 0;
}
.EventSummaryModal-module_root___gILFl .EventSummaryModal-module_bottomInfo___oV5Eb .EventSummaryModal-module_time___mdP6Z, .EventSummaryModal-module_root___gILFl .EventSummaryModal-module_bottomInfo___oV5Eb .EventSummaryModal-module_location___COmUu {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  align-items: center;
  display: flex;
  gap: 0.5rem;
}
.EventSummaryModal-module_root___gILFl .EventSummaryModal-module_eventSummarySection___OwlSo {
  align-items: center;
  display: flex;
}
.EventSummaryModal-module_root___gILFl .EventSummaryModal-module_bottomInfo___oV5Eb > *:not(:first-child) {
  flex-shrink: 0;
}
.EventSummaryModal-module_root___gILFl .EventSummaryModal-module_summary___NcbFD {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 30px 0 0 0;
}
.EventSummaryModal-module_root___gILFl .EventSummaryModal-module_separator___x0TWw {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/children/pricing/components/inventory/components/EventSummaryModal/EventSummaryModal.module.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAEE;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;AAAN;AAIE;EACE,mBAAA;EACA,aAAA;AAFJ;AAKE;EACE,cAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AAJJ;AAOE;EACE,aAAA;AALJ","sourcesContent":[".root {\r\n  padding:  20px 15px 20px 15px;\r\n  min-height: 260px;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  .headliner {\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    font-size: 1.6rem;\r\n    font-weight: 600;\r\n    line-height: 1.8rem;\r\n  }\r\n\r\n  .bottomInfo {\r\n    align-items: center;\r\n    display: flex;\r\n    gap: 2rem;\r\n    font-size: 1.4rem;\r\n    padding: 10px 0 0 0;\r\n\r\n    .time, .location {\r\n      text-overflow: ellipsis;\r\n      overflow: hidden;\r\n      white-space: nowrap;\r\n      align-items: center;\r\n      display: flex;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n\r\n  .eventSummarySection {\r\n    align-items: center;\r\n    display: flex;\r\n  }\r\n\r\n  .bottomInfo > *:not(:first-child) {\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .summary {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.5rem;\r\n    padding: 30px 0 0 0;\r\n  }\r\n\r\n  .separator {\r\n    display: none;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EventSummaryModal-module_root___gILFl`,
	"headliner": `EventSummaryModal-module_headliner___ZsqPi`,
	"bottomInfo": `EventSummaryModal-module_bottomInfo___oV5Eb`,
	"time": `EventSummaryModal-module_time___mdP6Z`,
	"location": `EventSummaryModal-module_location___COmUu`,
	"eventSummarySection": `EventSummaryModal-module_eventSummarySection___OwlSo`,
	"summary": `EventSummaryModal-module_summary___NcbFD`,
	"separator": `EventSummaryModal-module_separator___x0TWw`
};
export default ___CSS_LOADER_EXPORT___;
